import { render, staticRenderFns } from "./card-fields.vue?vue&type=template&id=2e63239a&scoped=true"
import script from "./card-fields.vue?vue&type=script&setup=true&lang=js"
export * from "./card-fields.vue?vue&type=script&setup=true&lang=js"
import style0 from "./card-fields.vue?vue&type=style&index=0&id=2e63239a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e63239a",
  null
  
)

export default component.exports